export const REFUND_STORE_CREDIT_START = 'REFUND_STORE_CREDIT_START';
export const REFUND_STORE_CREDIT_SUCCESS = 'REFUND_STORE_CREDIT_SUCCESS';
export const REFUND_STORE_CREDIT_ERROR = 'REFUND_STORE_CREDIT_ERROR';
export const REFUND_STORE_CREDIT_LOADING = 'REFUND_STORE_CREDIT_LOADING';
export const REFUND_STORE_CREDIT_CANCEL = 'REFUND_STORE_CREDIT_CANCEL';

export type Actions = {
  REFUND_STORE_CREDIT_START: { type: typeof REFUND_STORE_CREDIT_START; payload: boolean };
  REFUND_STORE_CREDIT_LOADING: { type: typeof REFUND_STORE_CREDIT_LOADING; payload: boolean };
  REFUND_STORE_CREDIT_SUCCESS: { type: typeof REFUND_STORE_CREDIT_SUCCESS; payload: any };
  REFUND_STORE_CREDIT_ERROR: { type: typeof REFUND_STORE_CREDIT_ERROR; payload: any };
  REFUND_STORE_CREDIT_CANCEL: { type: typeof REFUND_STORE_CREDIT_CANCEL; payload: any };
};
// Action Creators
export const actionCreators = {
  refundStoreCreditStart: (payload: any): Actions[typeof REFUND_STORE_CREDIT_START] => ({
    type: REFUND_STORE_CREDIT_START,
    payload,
  }),
  refundStoreCreditError: (payload: any): Actions[typeof REFUND_STORE_CREDIT_ERROR] => ({
    type: REFUND_STORE_CREDIT_ERROR,
    payload,
  }),
  refundStoreCreditSuccess: (payload: any): Actions[typeof REFUND_STORE_CREDIT_SUCCESS] => {
    return ({ type: REFUND_STORE_CREDIT_SUCCESS, payload: payload});
  },
  refundStoreCreditLoading: (payload: boolean): Actions[typeof REFUND_STORE_CREDIT_LOADING] => ({
    type: REFUND_STORE_CREDIT_LOADING,
    payload,
  }),
  refundStoreCreditCancel: (payload: boolean): Actions[typeof REFUND_STORE_CREDIT_CANCEL] => ({
    type: REFUND_STORE_CREDIT_CANCEL,
    payload,
  }),
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/accounts/refundstorecredit/actions.ts